export default __webpack_public_path__ + "static/diamond_b.9013120974e98100ba0f814990c738f8.svg";